import React from 'react';
import '../App.css';


function SignUp () {
    return <h1 className='sign-up'>SIGN UP</h1>
}

export default SignUp;